import React, { useEffect, useState } from 'react';
import { Card, Grid, CardContent, Typography, Button } from '@mui/material';
import { toast } from 'react-toastify';
import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';
import { checkIfAdmin } from '../functions/helpers/user';

const token = localStorage.getItem('token');
const userID = localStorage.getItem('userID');

function Inbox() {
  const stringifiedUser = localStorage.getItem('user');
  const user = JSON.parse(stringifiedUser);
  const [isAdmin, setIsAdmin] = useState(false);
  const [notifs, setNotifs] = useState([]);

  useEffect(() => {
    async function fetchData() {
      let allNotifs = [];
      const isAdminResponse = await checkIfAdmin(userID, token);
      setIsAdmin(isAdminResponse);
      const response = await apiRequest('get', null, `/notif/list/0`, token, null, {}, true);
      if (isAdminResponse) {
        allNotifs = await apiRequest('get', null, `/create/event/requests`, token);
      }
      setNotifs([...allNotifs, ...response.data]);
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  const CreditAddition = (
    type,
    prog_id,
    from_user,
    id,
    creds,
    clocked_hours
  ) => {
    if (type === 3) {
      //console.log('type 3');
      fetch(process.env.REACT_APP_API_URL + `/api/act/credit/${prog_id}`, {
        method: 'PUT',
        body: JSON.stringify({
          creds: `${clocked_hours}`,
        }),
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then((data) => {
          //console.log(data);
          if (data['success'] === 'Updated Successfully') {
            toast.success('Time Cred$ sent');
            handleSubmit(id);
          } else {
            toast.error('Credit Balance insufficient');
          }
        });
    } else if (type === 5) {
      fetch(
        process.env.REACT_APP_API_URL +
        `/api/user/credit/${from_user}/${prog_id}`,
        {
          method: 'PUT',
          body: JSON.stringify({
            creds: `${creds}`,
            clocked_hours: `${creds}`,
            notif_type: 5,
          }),
          headers: {
            Authorization: `Token ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          //console.log(data);
          if (data['success'] === 'Updated Successfully') {
            toast.success('Time Cred$ sent');
            handleSubmit(id);
          } else {
            toast.error('Credit Balance insufficient');
          }
        });
    } else {
      fetch(
        process.env.REACT_APP_API_URL +
        `/api/user/credit/${from_user}/${prog_id}`,
        {
          method: 'PUT',
          body: JSON.stringify({
            creds: `${clocked_hours}`,
            clocked_hours: `${clocked_hours}`,
            notif_type: 1,
          }),
          headers: {
            Authorization: `Token ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          //console.log(data);
          if (data['success'] === 'Updated Successfully') {
            toast.success('Time Cred$ sent');
            handleSubmit(id);
          } else {
            toast.error('Credit Balance insufficient');
          }
        });
    }
  };

  const handleSubmit = (id) => {
    fetch(process.env.REACT_APP_API_URL + `/api/notif/send/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data);
        window.location.href = '/inbox';
      });
  };

  return (
    <div>
      <Card>
        <Grid container>
          <Grid item md={10} sm={12} xs={12}>
            <Grid
              container
              spacing={1}
              style={{
                backgroundColor: '#ffffff',
                zIndex: 10,
                borderRadius: 30,
                marginTop: 10,
                fontSize: 20,
                fontFamily: 'Raleway',
                textAlign: 'center',
              }}
            >
              <Grid item md={1}></Grid>
              <Grid item xs={12} style={{ fontSize: 60 }}>
                Credit Exchanges
              </Grid>
              <Grid item xs={12}>
                Current time cred$: {user['creds']}
              </Grid>
              <Grid item xs={12}>
                Your credit requests will appear here
              </Grid>
              <Grid item xs={12}></Grid>
              <Grid container style={{ textAlign: 'left' }}>
                {notifs.length > 0
                  ? notifs.map((info, idx) => {
                    if (info.notif_type === 5) {
                      return (
                        <Grid item md={4} key={idx}>
                          <Card style={{ marginLeft: 15, marginRight: 15 }}>
                            <CardContent>
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography>
                                    {' '}
                                    From: {info.from_username}{' '}
                                  </Typography>{' '}
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography>
                                    {' '}
                                    Event: {info.program_name}{' '}
                                  </Typography>{' '}
                                </Grid>
                                <br></br>
                                <Grid container style={{ marginTop: 12 }}>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      <strong>
                                        Reason for request :
                                      </strong>{' '}
                                      {info.message}{' '}
                                    </Typography>{' '}
                                    &nbsp;
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      Credits to donate: {info.creds}{' '}
                                    </Typography>{' '}
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      Date: {info.date}
                                    </Typography>{' '}
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    style={{ justifyContent: 'center' }}
                                  >
                                    {' '}
                                    <br></br>
                                    <Button
                                      onClick={() => {
                                        CreditAddition(
                                          info.notif_type,
                                          info.program,
                                          info.from_user,
                                          info.id,
                                          info.creds,
                                          info.clocked_hours
                                        );
                                      }}
                                    >
                                      <i
                                        className='material-icons'
                                        style={{ color: 'green' }}
                                      >
                                        check_circle
                                      </i>
                                    </Button>{' '}
                                    <Button
                                      onClick={() => {
                                        handleSubmit(info.id);
                                      }}
                                    >
                                      <i
                                        className='material-icons'
                                        style={{ color: 'red' }}
                                      >
                                        cancel
                                      </i>
                                    </Button>{' '}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    } else if (info.notif_type === 3) {
                      return (
                        <Grid item md={4} key={idx}>
                          <Card style={{ marginLeft: 15, marginRight: 15 }}>
                            <CardContent>
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography>
                                    {' '}
                                    From: {info.from_username}{' '}
                                  </Typography>{' '}
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography>
                                    {' '}
                                    Event: {info.program_name}{' '}
                                  </Typography>{' '}
                                </Grid>
                                <br></br>
                                <Grid container style={{ marginTop: 12 }}>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      <strong>
                                        Contribution to the event:
                                      </strong>{' '}
                                      {info.message}{' '}
                                    </Typography>{' '}
                                    &nbsp;
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      Requesting Cred$: {
                                        info.clocked_hours
                                      }{' '}
                                    </Typography>{' '}
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      Date: {info.date}
                                    </Typography>{' '}
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    style={{ justifyContent: 'center' }}
                                  >
                                    {' '}
                                    <br></br>
                                    <Button
                                      onClick={() => {
                                        CreditAddition(
                                          info.notif_type,
                                          info.program,
                                          info.from_user,
                                          info.id,
                                          info.creds,
                                          info.clocked_hours
                                        );
                                      }}
                                    >
                                      <i
                                        className='material-icons'
                                        style={{ color: 'green' }}
                                      >
                                        check_circle
                                      </i>
                                    </Button>{' '}
                                    <Button
                                      onClick={() => {
                                        handleSubmit(info.id);
                                      }}
                                    >
                                      <i
                                        className='material-icons'
                                        style={{ color: 'red' }}
                                      >
                                        cancel
                                      </i>
                                    </Button>{' '}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    } else {
                      return (
                        <Grid item md={4} key={idx}>
                          <Card style={{ marginLeft: 15, marginRight: 15 }}>
                            <CardContent>
                              <Grid container>
                                <Grid item xs={12}>
                                  <Typography>
                                    {' '}
                                    From: {info.from_username}{' '}
                                  </Typography>{' '}
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography>
                                    {' '}
                                    Event: {info.program_name}{' '}
                                  </Typography>{' '}
                                </Grid>
                                <br></br>
                                <Grid container style={{ marginTop: 12 }}>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      <strong>
                                        Contribution to the event:
                                      </strong>{' '}
                                      {info.message}{' '}
                                    </Typography>{' '}
                                    &nbsp;
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      Clocked Hours: {info.clocked_hours}{' '}
                                    </Typography>{' '}
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography>
                                      {' '}
                                      Date: {info.date}
                                    </Typography>{' '}
                                  </Grid>

                                  <Grid
                                    item
                                    xs={12}
                                    style={{ justifyContent: 'center' }}
                                  >
                                    {' '}
                                    <br></br>
                                    <Button
                                      onClick={() => {
                                        CreditAddition(
                                          info.notif_type,
                                          info.program,
                                          info.from_user,
                                          info.id,
                                          info.creds,
                                          info.clocked_hours
                                        );
                                      }}
                                    >
                                      <i
                                        className='material-icons'
                                        style={{ color: 'green' }}
                                      >
                                        check_circle
                                      </i>
                                    </Button>{' '}
                                    <Button
                                      onClick={() => {
                                        handleSubmit(info.id);
                                      }}
                                    >
                                      <i
                                        className='material-icons'
                                        style={{ color: 'red' }}
                                      >
                                        cancel
                                      </i>
                                    </Button>{' '}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    }
                  })
                  : ''}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={2} sm={12} xs={12}>
            <Grid item md={12} sm={12} xs={12}>
              {isAdmin ? (
                <Button
                  onClick={() => {
                    window.location.href = '/programs/approvals';
                  }}
                  style={{
                    backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                    color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                    borderRadius: 30,
                    fontFamily: 'Raleway',
                    marginBottom: 30,
                    padding: 10,
                    marginTop: 10,
                  }}
                >
                  Program Approvals
                </Button>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
}

export default Inbox;
